import isBrowser from '../../utils/isBrowser'
import { ProductClassification } from '../productClassification'
import ProductComparisonBrand from '../ProductComparisonBrand'
import ProductDynamicImage from '../ProductDynamicImage'
import ProductImage from '../ProductImage'
import ProductOptionValue, { ProductOption } from '../ProductOption'
import ProductTag from '../ProductTag'
import { BaseProductVariant } from '../ProductVariant'

import { PRODUCT_TYPES } from './BundleProduct'
import PRODUCT_DOMAIN_TYPES from './ProductDomainTypes'

import type { DeliveryDetailsByColorType } from '../ProductDeliveryDetails'

export interface IBaseProduct<GenProductVariant extends BaseProductVariant = BaseProductVariant> {
  readonly id: number | string
  readonly title: string
  readonly slug: string
  readonly productOptions: ProductOption[]
  readonly variants: GenProductVariant[] | undefined
  readonly images: ProductImage[]
  readonly dynamicImages: ProductDynamicImage[] | null
  readonly tags: ProductTag[]
  readonly spid: number | string
  readonly childSpids?: number[]
  readonly comparisonBrands?: ProductComparisonBrand[]
  readonly showAllColors?: boolean // TODO: handle in the API
  readonly type?: PRODUCT_TYPES
  readonly mergeOption?: string
  readonly delivery_info?: DeliveryDetailsByColorType
  readonly isValentineProduct?: boolean
  readonly new_color_options?: ProductOptionValue[]
  readonly classification?: ProductClassification
  readonly isWhiteGloveDeliveryAvailable?: boolean
}

export default abstract class BaseProduct<
  GenProductVariant extends BaseProductVariant = BaseProductVariant,
> implements IBaseProduct<GenProductVariant> {
  // eslint-disable-next-line i18next/no-literal-string
  readonly typename = 'Product'
  readonly isConstructedOnServer: boolean
  readonly id: number | string
  readonly title: string
  readonly slug: string
  readonly productOptions: ProductOption[]
  readonly variants: GenProductVariant[] | undefined
  readonly images: ProductImage[]
  readonly dynamicImages: ProductDynamicImage[] | null
  readonly tags: ProductTag[]
  readonly productDomainTypes: PRODUCT_DOMAIN_TYPES
  readonly spid: number | string
  readonly childSpids?: number[]
  readonly showAllColors?: boolean
  readonly comparisonBrands?: ProductComparisonBrand[]
  readonly type = PRODUCT_TYPES.NORMAL
  readonly mergeOption?: string
  readonly delivery_info?: DeliveryDetailsByColorType
  readonly isValentineProduct?: boolean
  readonly new_color_options?: ProductOptionValue[]
  readonly classification?: ProductClassification
  readonly isWhiteGloveDeliveryAvailable?: boolean

  constructor(
    {
      id,
      title,
      slug,
      productOptions,
      variants,
      images,
      dynamicImages,
      tags,
      spid,
      childSpids,
      showAllColors = false,
      comparisonBrands,
      mergeOption,
      delivery_info,
      isValentineProduct,
      new_color_options,
      classification,
      isWhiteGloveDeliveryAvailable,
    }: IBaseProduct<GenProductVariant>,
    productDomainTypes: PRODUCT_DOMAIN_TYPES,
  ) {
    this.id = isNaN(Number(id)) ? id : Number(id)
    this.title = title
    this.slug = slug
    this.productOptions = productOptions
    this.variants = variants
    this.images = images
    this.dynamicImages = dynamicImages ?? []
    this.tags = tags
    this.isConstructedOnServer = !isBrowser()
    this.productDomainTypes = productDomainTypes
    this.spid = isNaN(Number(spid)) ? id : Number(spid)
    this.childSpids = childSpids
    this.showAllColors = showAllColors
    this.comparisonBrands = comparisonBrands
    this.mergeOption = mergeOption
    this.delivery_info = delivery_info
    this.isValentineProduct = isValentineProduct
    this.new_color_options = new_color_options
    this.classification = classification
    this.isWhiteGloveDeliveryAvailable = isWhiteGloveDeliveryAvailable
    return {
      ...this,
    }
  }
}
